import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
const { Text, Title } = Typography;

const Detail = (props) => {
  const { name, record, minutes, currency, warning, style, highlight } = props;
  const intl = useIntl();
  const title = record
    ? minutes
      ? Math.round((record[name] / 60) * 100) / 100
      : currency
      ? new Intl.NumberFormat("he", {
          style: "currency",
          currency: "ILS",
          maximumFractionDigits: 2,
        }).format(record[name])
      : record[name]
    : record[name];
  return (
    <div
      style={{
        borderRadius: "5px",
        border: "1px dashed rgba(120, 120, 120, 0.32)",
        display: "flex",
        flexDirection: "column",
        padding: "5px 10px",
        backgroundColor: highlight ? "#fffbe6" : "transparent",
      }}
    >
      <Text ellipsis>
        {intl.formatMessage({
          id: `app.prospectuses.${name}`,
        })}
      </Text>
      <Title
        level={5}
        ellipsis
        style={{
          margin: "0px",
          color: warning && record[name] > 0 ? "red" : "inherit",
          ...style,
        }}
      >
        {title}
      </Title>
    </div>
  );
};

export default Detail;
